import { render, staticRenderFns, recyclableRender, components } from "./nsh_mask.vue?vue&type=template&id=9f0b5ba8&scoped=true&"
var renderjs
import script from "./nsh_mask.vue?vue&type=script&lang=js&"
export * from "./nsh_mask.vue?vue&type=script&lang=js&"
import style0 from "./nsh_mask.vue?vue&type=style&index=0&id=9f0b5ba8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../Applications/HBuilderX.app/Contents/HBuilderX/plugins/uniapp-cli/node_modules/@dcloudio/vue-cli-plugin-uni/packages/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f0b5ba8",
  null,
  false,
  components,
  renderjs
)

export default component.exports